import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class OnboardingLoginStepOneError extends BaseEitherError {}

export type TOnboardingLoginStepOneOperationErrors = OnboardingLoginStepOneError;
